import { render, staticRenderFns } from "./AuthorsReferenceField.vue?vue&type=template&id=6557f67c&scoped=true&"
import script from "./AuthorsReferenceField.vue?vue&type=script&lang=js&"
export * from "./AuthorsReferenceField.vue?vue&type=script&lang=js&"
import style0 from "./AuthorsReferenceField.vue?vue&type=style&index=0&id=6557f67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557f67c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
